<template>
  <div class="flow-root">
    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle px-4">
        <table class="min-w-full">
          <slot name="tableHeaders" />
          <slot name="tableBody" />
        </table>
      </div>
    </div>
  </div>
</template>
